import React, { useEffect, useState } from "react";

import logger from "../../../../../../utils/LoggerFrontend";
import { useTranslation } from "react-i18next";

import {
  SearchIcon,
  AddIcon,
  HearthIcon,
  HomeIcon,
  MessageIcon,
  PersonIcon,
  ReplyIcon,
  TiktokInboxIcon,
  NoteIcon
} from "../../../../Previews/Svg";
import { channelsByShortName } from "../../../../../../data/app__channels";
import { TIKTOK_IMAGE_SIZE_SPEC } from "./PrintPostEditorTikTok.constants";
import * as SC from "./PrintPostEditorTikTok.styled.js";

import PrintCampaignCreateTeaserEditor from "../../print-campaign-create-teaser-editor/PrintCampaignCreateTeaserEditor";
import PrintCampaignCreatePhotoEditor from "../../print-campaign-create-photo-editor/PrintCampaignCreatePhotoEditor.jsx";
import PrintCampaignCreateChannelDataEditor from "../../print-channel-editor/PrintCampaignCreateChannelDataEditor";
import PrintTemplateEditor from "../../print-campaign-template-editor/PrintTemplateEditor";

const PrintPostEditorTikTok = ({
  orgaId,
  postData,
  channelData,
  editable,
  selectedCreativeIndexToEdit,
  clientView
}) => {
  const initialPreviewType = postData.videoData?.isGenerated ? "video" : "normal";
  const [previewType, setPreviewType] = useState(initialPreviewType);
  const { t } = useTranslation();

  useEffect(() => {
    if (postData.videoData?.isGenerated) {
      setPreviewType("video");
    } else {
      setPreviewType("normal");
    }
  }, [postData?.videoData]);

  const renderNormalTikTok = () => {
    return (
      <SC.PostEditorTikTokWrapper>
        <SC.TikTokWrapper>
          <SC.PhotoWrapper>
            <SC.HeaderWrapper>
              <SC.MobileHead>9:41</SC.MobileHead>
              <SC.HeaderMenu>
                {t("Following")} | <SC.SelectedMenuItem>{t("For You")}</SC.SelectedMenuItem>
              </SC.HeaderMenu>
            </SC.HeaderWrapper>
            <PrintCampaignCreatePhotoEditor
              orgaId={orgaId}
              selectedCreativeIndexToEdit={selectedCreativeIndexToEdit}
              creatives={postData.creatives}
              minHeight={TIKTOK_IMAGE_SIZE_SPEC.minHeight}
              maxHeight={TIKTOK_IMAGE_SIZE_SPEC.maxHeight}
              minAspect={channelsByShortName.tiktok.minAspect}
              maxAspect={channelsByShortName.tiktok.maxAspect}
              width={TIKTOK_IMAGE_SIZE_SPEC.pictureWidth}
              editable={editable}
              borderRadius="10px 10px 0 0"
              allowVideos={channelsByShortName.tiktok.allowVideos}
            />
            <SC.EditorWrapper>
              <SC.CompanyName>
                @
                <PrintCampaignCreateChannelDataEditor
                  value={channelData.companyName}
                  dataKey="companyName"
                  textStyle={SC.companyNameStyle}
                  limit={channelsByShortName.tiktok.limits.companyName}
                  label={t("Company name")}
                  tooltip={t("Company name")}
                  editable={editable}
                  padding="3px 10px 3px 1px"
                  dark
                />
              </SC.CompanyName>
              <PrintCampaignCreateTeaserEditor
                channel="tiktok"
                teaserText={postData.teaserText}
                teaserTextStyle={SC.teaserTextStyle}
                smallButtons
                minRows={1}
                editable={editable}
                limit={channelsByShortName.tiktok.limits.teaserText}
                bannedCharaters={["#"]}
                dark
                isAutoGenerated={postData?.isAutoGenerated}
                isEdited={postData?.editedStates?.teaserText}
              />
              <SC.PromotionalText>
                <NoteIcon />
                {t("Promotional Music")}
              </SC.PromotionalText>
            </SC.EditorWrapper>
            <SC.RightMenu>
              <SC.MenuItem>
                <HearthIcon />
                <div>328.7K</div>
              </SC.MenuItem>
              <SC.MenuItem>
                <MessageIcon />
                <div>578</div>
              </SC.MenuItem>
              <SC.MenuItem>
                <ReplyIcon style={{ transform: "scale(-1, 1)" }} />
                <div>{t("Share")}</div>
              </SC.MenuItem>
            </SC.RightMenu>
          </SC.PhotoWrapper>
          <SC.FooterWrapper>
            <SC.MenuItem>
              <HomeIcon />
              <div>{t("Home")}</div>
            </SC.MenuItem>
            <SC.MenuItem>
              <SearchIcon style={{ margin: "4px -5px -4px 0px" }} />
              <div>{t("Discovery")}</div>
            </SC.MenuItem>
            <SC.Add>
              <AddIcon />
            </SC.Add>
            <SC.MenuItem>
              <TiktokInboxIcon />
              <div>{t("Inbox")}</div>
            </SC.MenuItem>
            <SC.MenuItem>
              <PersonIcon />
              <div>{t("Me")}</div>
            </SC.MenuItem>
            <SC.WhiteLine />
          </SC.FooterWrapper>
        </SC.TikTokWrapper>
      </SC.PostEditorTikTokWrapper>
    );
  };

  const renderVideoTikTok = () => {
    return (
      <SC.PostEditorTikTokWrapper>
        <SC.TikTokWrapper>
          <SC.PhotoWrapper>
            <SC.HeaderWrapper>
              <SC.MobileHead>9:41</SC.MobileHead>
              <SC.HeaderMenu>
                {t("Following")} | <SC.SelectedMenuItem>{t("For You")}</SC.SelectedMenuItem>
              </SC.HeaderMenu>
            </SC.HeaderWrapper>
            <PrintTemplateEditor
              selectedMediaAssetIndexToEdit={selectedCreativeIndexToEdit}
              videoData={postData.videoData || null}
              templateType="video"
              channel="tiktok"
            />
            <SC.EditorWrapper isVideo>
              <SC.CompanyName>
                @
                <PrintCampaignCreateChannelDataEditor
                  value={channelData.companyName}
                  dataKey="companyName"
                  textStyle={SC.companyNameStyle}
                  limit={channelsByShortName.tiktok.limits.companyName}
                  label={t("Company name")}
                  tooltip={t("Company name")}
                  editable={editable}
                  padding="3px 10px 3px 1px"
                  dark
                />
              </SC.CompanyName>
              <PrintCampaignCreateTeaserEditor
                channel="tiktok"
                teaserText={postData.teaserText}
                teaserTextStyle={SC.teaserTextStyle}
                smallButtons
                minRows={1}
                editable={editable}
                limit={channelsByShortName.tiktok.limits.teaserText}
                bannedCharaters={["#"]}
                dark
                isAutoGenerated={postData?.isAutoGenerated}
                isEdited={postData?.editedStates?.teaserText}
              />
              <SC.PromotionalText>
                <NoteIcon />
                {t("Promotional Music")}
              </SC.PromotionalText>
            </SC.EditorWrapper>
            <SC.RightMenu isVideo>
              <SC.MenuItem>
                <SC.Edit />
              </SC.MenuItem>
              <SC.MenuItem>
                <HearthIcon />
                <div>328.7K</div>
              </SC.MenuItem>
              <SC.MenuItem>
                <MessageIcon />
                <div>578</div>
              </SC.MenuItem>
              <SC.MenuItem>
                <ReplyIcon style={{ transform: "scale(-1, 1)" }} />
                <div>{t("Share")}</div>
              </SC.MenuItem>
            </SC.RightMenu>
          </SC.PhotoWrapper>
          <SC.FooterWrapper>
            <SC.MenuItem>
              <HomeIcon />
              <div>{t("Home")}</div>
            </SC.MenuItem>
            <SC.MenuItem>
              <SearchIcon style={{ margin: "4px -5px -4px 0px" }} />
              <div>{t("Discovery")}</div>
            </SC.MenuItem>
            <SC.Add>
              <AddIcon />
            </SC.Add>
            <SC.MenuItem>
              <TiktokInboxIcon />
              <div>{t("Inbox")}</div>
            </SC.MenuItem>
            <SC.MenuItem>
              <PersonIcon />
              <div>{t("Me")}</div>
            </SC.MenuItem>
            <SC.WhiteLine />
          </SC.FooterWrapper>
        </SC.TikTokWrapper>
      </SC.PostEditorTikTokWrapper>
    );
  };

  logger.debug("PostEditorTikTok:render", "render:", {
    postData,
    channelData,
    editable,
    clientView
  });

  return (
    <section
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
        width: "100%",
        alignItems: "center"
      }}
    >
      <div>{previewType === "normal" ? renderNormalTikTok() : renderVideoTikTok()}</div>
    </section>
  );
};

export default PrintPostEditorTikTok;
